import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { APP_LABELS } from '@config/app-config';

import { getCampReportsDashboardOverviewData } from '@redux/overnight-camp-data-overview/action';
import { postOvernightCampDataReviewSubmit } from '@redux/overnight-camp-data-review-and-submit/action';

import { ReviewSubmitInfoSelector } from '@redux/review-submit/selectors';
import { ApiParaSelector } from '@redux/overnight-camp-data-apiParameter/selectors';

import ErrorPopup from '@modules/employee-data-collection/components/upload-file/error-popup';

import Inprogress from '@static/images/Inprogress.svg';
import submitReview from '@static/images/submitReview.svg';
import closeIcomoons from '@static/images/closeIcomoons.svg';

const Popup = props => {
  const {
    setLoader,
    modalOpen,
    fromValues,
    setShowPopup,
    ApiParameterData,
    inCompleteList,
    setSubmitStatus,
    handleClosePopup,
    handlePostReviewSubmit,
    ReviewSubmitInfoSelectorData,
    handleGetCampReportsDashboard
  } = props;

  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleFinalSubmit = () => {
    setLoader(true);
    const payloadData = {
      ReviewsubmitId:
        ReviewSubmitInfoSelectorData?.reviewSubmitData?.reviewsubmitId || 0,
      Year: ApiParameterData?.year,
      BranchNumber: ApiParameterData?.branchNumber,
      ReportBatchId: ApiParameterData?.reportBatchId,
      RecordStatus:
        ReviewSubmitInfoSelectorData?.reviewSubmitData?.recordStatus || '',
      ShareCampData: fromValues?.ShareCampData === 'yes',
      ShareACASurvey: fromValues?.ShareACASurvey === 'yes'
    };

    handlePostReviewSubmit(payloadData)
      .then(res => {
        if (res && res.status === 201) {
          setLoader(false);
          setSubmitStatus(true);
          setShowPopup(true);
          handleGetCampReportsDashboard(
            ApiParameterData?.branchNumber,
            ApiParameterData?.year
          );
        } else if (res.statusCode === 409) {
          handleClosePopup();
          setShowPopup(false);
          setLoader(false);
          setErrorMessage(res.errorMessage);
          setErrorPopup(true);
        } else {
          setShowPopup(true);
          setSubmitStatus(false);
          setLoader(false);
        }
      })
      .catch(() => {
        setSubmitStatus(false);
        setLoader(false);
      });
  };

  const showHideClassName = modalOpen ? 'modal d-block' : 'modal d-none';
  const modal = {
    background: 'rgb(0 0 0 / 0.5)'
  };

  return (
    <div>
      {inCompleteList.length === 0 ||
      (inCompleteList[0]?.status === 'Completed' &&
        inCompleteList[1]?.status === 'Completed' &&
        inCompleteList[2]?.status === 'Completed' &&
        inCompleteList[3]?.status === 'Completed') ? (
        <div
          className={`${showHideClassName}  ymca-submitMyReview`}
          style={modal}
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered ymca-dialogModel">
            <div className="modal-content ymca-content">
              <div className="modal-body text-center ymca-body">
                <div>
                  <button
                    type="button"
                    className="ymca-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      handleClosePopup();
                    }}
                  >
                    <img
                      src={closeIcomoons}
                      alt="close"
                      className="img-fluid"
                    />
                  </button>
                  <img src={submitReview} alt="" className="img-fluid" />
                  <h4>You’re almost done!</h4>
                  <p>{APP_LABELS.REVIEW_SUBMIT_CAMP_ALERT_INFO}</p>
                  <button
                    className="btn ymca-submitBlue d-flex"
                    data-bs-dismiss="modal"
                    type="button"
                    onClick={handleFinalSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`${showHideClassName}  ymca-moduleInComplete`}
          id="exampleModal"
          style={modal}
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered ymca-dialogModel">
            <div className="modal-content ymca-content">
              <div className="modal-body text-center ymca-body">
                <div>
                  <div className="ymca-headerArea d-flex">
                    <img
                      src={Inprogress}
                      alt="inprogress"
                      className="img-fluid"
                    />
                    <div className="ymca-texArea">
                      <h4>Some Modules are Not Completed!</h4>
                      <p>Please complete all modules and try.</p>
                    </div>
                    <button
                      type="button"
                      className="ymca-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        handleClosePopup();
                      }}
                    >
                      <img
                        src={closeIcomoons}
                        alt="close"
                        className="img-fluid"
                      />
                    </button>
                  </div>
                  <div className="ymca-tableResponsive">
                    <table className="table ymca-modelTable">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Module Name</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {inCompleteList?.map(
                          (data, index) =>
                            data?.status?.toUpperCase() !==
                              APP_LABELS.STATUS_COMPLETED && (
                              <tr key={data?.name?.replace(/ /g, '_')}>
                                <td>{index + 1}</td>
                                <td>{data?.name}</td>
                                <td>
                                  <lable
                                    className={`${
                                      data?.status?.toUpperCase() ===
                                        APP_LABELS.STATUS_IN_PROGRESS ||
                                      data?.status?.toUpperCase() ===
                                        APP_LABELS.STATUS_INPROGRESS
                                        ? 'ymca-progressIn'
                                        : 'ymca-danger'
                                    } `}
                                  >
                                    {data?.status?.toUpperCase() ===
                                      APP_LABELS.STATUS_IN_PROGRESS ||
                                    data?.status?.toUpperCase() ===
                                      APP_LABELS.STATUS_INPROGRESS
                                      ? 'IN PROGRESS'
                                      : 'NOT STARTED'}
                                  </lable>
                                </td>
                              </tr>
                            )
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="ymca-varientTwo">
                    <button
                      className="btn ymca-savingBTN ymca-submitBuble ymca-ok-btn"
                      data-bs-dismiss="modal"
                      type="button"
                      onClick={() => {
                        handleClosePopup();
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <ErrorPopup
        handleCloseErrorPopup={() => {
          setErrorPopup(false);
        }}
        errorMessage={errorMessage}
        showErrorPopup={errorPopup}
      />
    </div>
  );
};

Popup.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  setLoader: PropTypes.func.isRequired,
  setShowPopup: PropTypes.func.isRequired,
  setSubmitStatus: PropTypes.func.isRequired,
  handleClosePopup: PropTypes.func.isRequired,
  handlePostReviewSubmit: PropTypes.func.isRequired,
  handleGetCampReportsDashboard: PropTypes.func.isRequired,

  fromValues: PropTypes.objectOf(PropTypes.any).isRequired,
  inCompleteList: PropTypes.arrayOf(PropTypes.any).isRequired,
  ApiParameterData: PropTypes.objectOf(PropTypes.any).isRequired,
  ReviewSubmitInfoSelectorData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = state => ({
  ReviewSubmitData: ReviewSubmitInfoSelector(state),
  ApiParameterData: ApiParaSelector(state)
});

const mapDispatchToProps = {
  handlePostReviewSubmit: postOvernightCampDataReviewSubmit,
  handleGetCampReportsDashboard: getCampReportsDashboardOverviewData
};

export default connect(mapStateToProps, mapDispatchToProps)(Popup);
